import Svg, { Path } from "react-native-svg";
import type { SvgProps } from "react-native-svg";
import { memo } from "react";
const SvgDotsDividerMed = (props: SvgProps) => <Svg xmlns="http://www.w3.org/2000/svg" width={4} height={86} fill="none" viewBox="0 0 4 86" {...props}><Path stroke="currentColor" strokeDasharray="0.5 9" strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M2 84V2" /></Svg>;
const Memo = memo(SvgDotsDividerMed);
export default Memo;